import { required, maxLength, numeric, decimal } from 'vuelidate/lib/validators'
import { slugValidator, unitsValidator } from '@/utils/validations/validations'
// minLength,
export default {
  slug: {
    required: {
      validator: required,
      message: 'Обязательное поле'
    },
    slugValidator: {
      validator: slugValidator,
      message: 'Уникальное имя slug может состоять только из цифр, латинских букв и символов тире'
    }
  },
  dimensions: {
    units: {
      validator: unitsValidator,
      message: 'Разрешены только единицы измерения (100px | 15% | 5rem)'
    }
  },
  sortOrder: {
    numeric: {
      validator: numeric,
      message: 'Поле принимает только числовые значения'
    }
  },
  title: {
    required: {
      validator: required,
      message: 'Обязательное поле'
    },
    maxLength: { validator: maxLength(100), message: 'Максимальное значение 100' }
  },
  subtitle: {
    maxLength: {
      validator: maxLength(1000),
      message: 'Превышена допустимая длинна поля'
    }
  },
  description: {
    maxLength: {
      validator: maxLength(1000),
      message: 'Превышена допустимая длинна поля'
    }
  },
  name: {
    required: {
      validator: required,
      message: 'Обязательное поле'
    },
    maxLength: {
      validator: maxLength(1000),
      message: 'Превышена допустимая длинна поля'
    }
  },
  area: {
    required: {
      validator: required,
      message: 'Обязательное поле'
    },
    decimal: {
      validator: decimal,
      message: 'Поле принимает только числовые значения'
    }
  },
  population: {
    required: {
      validator: required,
      message: 'Обязательное поле'
    },
    numeric: {
      validator: numeric,
      message: 'Поле принимает только числовые значения'
    }
  }
}
